import AppHeader from '../AppHeader'
export default {
  name: 'magazine-list',
  created () {
    var year = this.getYear()
    this.magazineGet(year)
  },
  data () {
    return {
      magazineCallbackFlag: null,
      selectYear: null
    }
  },
  computed: {
    magazines () {
      return this.$store.getters.magazines
    },
    years() {
      var ret = []
      var start_year = Number(this.$store.getters.magazineMinYear)
      var year = this.getYear() + 1
      for (var i=start_year; i<year; i++) {
        ret.push(i)
      }
      return ret
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goTop: function() {
      this.$router.push({ path: '/'})
    },
    getYear: function() {
      var today = new Date()
      var year = today.getFullYear()
      return year
    },
    goMagazinePdf: function(path) {
      var url = path + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      window.open(url, '_blank')
    },
    magazineGet: function (year) {
      this.magazineCallbackFlag = false
      var data = {
        'target_year': year,
        'only_new': false
      }
      var self = this
      var callback = function () {
        self.magazineCallbackFlag = true
        self.selectYear = year
      }

      this.$store.dispatch('GET_MAGAZINE', { data: data, callback: callback })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/magazine-list.js